module.exports = __webpack_public_path__ + "static/phone-slide-3-en-9aa8295d886df1d88ad1f171deb3e89e.png";